import * as React from "react";
import { RouteConfig } from "react-router-config";
import { Route, Switch } from "react-router-dom";
import PageLayout from "./components/PageLayout";
import Admin from "./components/admin/admin";
import PlayProofreader from "./components/proofreaderActivities/container";

export const routes: RouteConfig[] = [
  {
    path: "/play/pf",
    render: (routeProps: any) => (
      <PlayProofreader
        {...routeProps}
        setHasPassageButtons={routeProps.setHasPassageButtons}
      />
    )
  },
  {
    path: "/admin",
    component: () => (<Admin />)
  }
];

export const route = (
  <Switch>
    <Route component={PageLayout} path="/" />
  </Switch>
);
